import React from "react";
import { withRouter } from "react-router-dom";
import { observer, inject } from "mobx-react";
import Routes from "Configs/routes";
import { sendMetriks } from "Services/sendMetriks";
import withDefaultParams, { generateUrl } from "Services/withDefaultParams";
import { SearchAddressInCatalog } from "ComponentsUI/SearchAddress";

@withRouter
@withDefaultParams
@inject("ApplicationModel")
@observer
export default class AddressSearchCatalogContainer extends React.Component {
	static defaultProps = {
		route: Routes.DomaNzl.route,
		searcheModel: null,
		onCallback: () => {},
		onInputCallback: () => {},
	};

	constructor(props) {
		super(props);
		let text = this.props.ApplicationModel.text;
		this.errorTextCommon = text.ADDRESS_ERROR;
		this.notCorrectHouse = text.NOT_CORRECT_HOUSE;
		this.errorTextWithoutHouse = text.ADDRESS_WITHOUT_HOUSE;
		this.dropdownSelectorVariants = [
			{
				id: 0,
				name: text.toHome,
				route: Routes.Rates.route,
			},
			{
				id: 1,
				name: text.toOffice,
				route: Routes.Business.route,
			},
			{
				id: 2,
				name: text.toOutHome,
				route: Routes.OrderOuthome.route,
			},
		];
		this.state = {
			error: false,
			errorTypeConnection: false,
			errorStreet: false,
			errorHouse: false,
			errorCounter: 0,
			selectedRoute: this.props.tender ? this.dropdownSelectorVariants[1] : -1,
			selFil: null,
		};
	}

	changeSelectRoute(item) {
		this.setState({
			...this.state,
			selectedRoute: item,
			errorTypeConnection: false,
		});
	}

	onMountSelFil = (e) => {
		this.setState({ selFil: e });
	};
	componentWillUnmount() {
		if (!this.props.withoutReset) {
			let searcheModel = this.props.searcheModel || this.props.ApplicationModel.searcheModel;
			if (!searcheModel.getCurrentStreet().id) {
				//searcheModel.resetData();
			}
		}
	}

	onInputHandler(field, value) {
		let searcheModel = this.props.searcheModel || this.props.ApplicationModel.searcheModel;
		this.removeError();
		if (field === "street") {
			searcheModel.updateValueStreet(value);
		} else {
			if (value.length === 1 && !/^[1-9]/.test(value)) {
				this.errorText = this.notCorrectHouse;
				this.setState({
					error: true,
					errorCounter: this.state.errorCounter + 1,
				});
				return;
			}
			searcheModel.updateValueAddress(value);
		}
		this.props.onInputCallback();
	}

	focusOnDropdownHouse() {
		this.houseDropdownInput && setTimeout(() => this.houseDropdownInput.focus(), 100);
	}

	onItemSelect(field, item) {
		let searcheModel = this.props.searcheModel || this.props.ApplicationModel.searcheModel;
		this.removeError();
		if (field === "street") {
			searcheModel.setCurrentStreet(item?.data);
			sendMetriks("CLICK_FIELD_HOUSE");
			this.focusOnDropdownHouse();
		} else {
			searcheModel.setCurrentAddress(item?.data);
			if (this.state.selectedRoute == -1) {
				this.state.selFil.state.focus = true;
			}
		}
		if (item?.data?.address_id) {
			this.props.onCallback(item.data);
		}
	}

	onDropdownOpenCallback() {
		let fixedModel = this.props.ApplicationModel.fixedPanelModel;
		fixedModel.hideFixedPanel();
	}

	onDropdownCloseCallback() {
		let fixedModel = this.props.ApplicationModel.fixedPanelModel;
		fixedModel.showFixedPanel();
	}

	removeError() {
		this.setState({
			error: false,
			errorHouse: false,
		});
	}

	goToRates() {
		let searcheModel = this.props.searcheModel || this.props.ApplicationModel.searcheModel;
		let link = null;
		let currentAddress = searcheModel.getCurrentAddress();
		let currentStreet = searcheModel.getCurrentStreet();
		if (!currentAddress.id) {
			let addresses = searcheModel.getAddresses();
			let finded = addresses.find(
				(item) =>
					item.data.full.toLowerCase() ===
					searcheModel.searcheForm.fields.address.value.toLowerCase()
			);
			if (!!finded) {
				currentAddress = finded.data;
				searcheModel.setCurrentAddress(finded.data);
			} else {
				currentAddress.id = -1;
			}
		}

		if (currentAddress.id === -1) {
			if (this.state.selectedRoute.route === this.dropdownSelectorVariants[0].route) {
				!!this.props.openPopup && this.props.openPopup();
				return;
			}

			let newRegionUrl = this.props.match.params.regionUrl;
			let regions = this.props.ApplicationModel.siteConfig.regions.available;
			let region = regions.find((item) => item.id == currentStreet.region_id);
			if (region.url != newRegionUrl) {
				newRegionUrl = region.url;
				this.props.ApplicationModel.detectRegionModel.setAccept(region);
				this.props.ApplicationModel.setRegion(region);
			}
			link = generateUrl(this.state.selectedRoute.route, {
				regionUrl: newRegionUrl,
			});
			if (this.state.selectedRoute.route === this.dropdownSelectorVariants[1].route) {
				link = link + `?u_house=1`;
			}
			!!this.props.successCallback && this.props.successCallback();
			this.props.history.push(link);
			return;
		}

		if (this.state.selectedRoute.route === this.dropdownSelectorVariants[0].route) {
			let commonViewModel = this.props.ApplicationModel.commonViewModel;
			if (this.props.providerId) {
				let providerModel = this.props.ApplicationModel.providerModel;
				providerModel.setProviderIdForOrder(this.props.providerId);
			}
			commonViewModel.changeShowModalOnRates(true);
		}

		let newRegionUrl = this.props.match.params.regionUrl;
		let regions = this.props.ApplicationModel.siteConfig.regions.available;
		let region = regions.find((item) => item.id == currentAddress.region_id);
		if (region.url != newRegionUrl) {
			newRegionUrl = region.url;
			this.props.ApplicationModel.detectRegionModel.setAccept(region);
			this.props.ApplicationModel.setRegion(region);
		}

		link = generateUrl(this.state.selectedRoute.route, {
			regionUrl: newRegionUrl,
		});
		if (
			this.state.selectedRoute.route === this.dropdownSelectorVariants[0].route ||
			this.state.selectedRoute.route === this.dropdownSelectorVariants[1].route
		) {
			searcheModel.setHouseId(currentAddress.id);
		}
		this.props.history.push(link);
	}

	onClickButton(e) {
		let searcheModel = this.props.searcheModel || this.props.ApplicationModel.searcheModel;
		let streetValue = searcheModel.searcheForm.fields.street.value;
		let addressValue = searcheModel.searcheForm.fields.address.value;
		let windowSize = this.props.ApplicationModel.windowSizeModel.windowSizes;
		!!this.props.onProviderConnect && this.props.onProviderConnect(this.props.data);
	}

	clickInputHandler() {
		this.props.clickInputHandler && this.props.clickInputHandler();
	}

	onEnter() {
		if (!!this.props.onEnterHandler) {
			this.props.onEnterHandler();
			return;
		}
		this.onClickButton();
	}

	setRefHouseDropdown(input) {
		this.houseDropdownInput = input;
	}

	render() {
		let searcheModel = this.props.searcheModel || this.props.ApplicationModel.searcheModel;
		let text = this.props.ApplicationModel.text;
		let currentAddress = searcheModel.getCurrentAddress();
		let currentStreet = searcheModel.getCurrentStreet();
		let streetValue = searcheModel.searcheForm.fields.street.value;
		let addressValue = searcheModel.searcheForm.fields.address.value;
		let windowSizes = this.props.ApplicationModel.windowSizeModel.windowSizes;
		/*if (!!this.props.shortValue) {
            let arrayValue = value.split(",");
            value = arrayValue[arrayValue.length - 1];
        }*/
		// let arrayValue = value.split(",");
		// value = arrayValue[arrayValue.length - 1];
		let popupBView = this.props.ApplicationModel.modalModel.popapB;
		let providerName = this.props.data.name;
		return (
			<SearchAddressInCatalog
				errorTypeConnection={this.state.errorTypeConnection}
				modalIsOpen={this.props.ApplicationModel.modalModel.isOpen}
				popupBView={popupBView}
				clickInputHandler={() => this.clickInputHandler()}
				text={text}
				showList={true}
				itemsStreets={searcheModel.getStreets()}
				itemsAddresses={searcheModel.getAddresses()}
				error={this.props.error || this.state.error}
				errorStreet={this.props.error || this.state.errorStreet}
				errorHouse={this.props.error || this.state.errorHouse}
				errorCounter={this.state.errorCounter}
				onClickButton={() => this.onClickButton()}
				onInputHandler={(field, value) => this.onInputHandler(field, value)}
				onItemSelect={(field, item) => this.onItemSelect(field, item)}
				streetValue={streetValue}
				addressValue={addressValue}
				tender={this.props.tender}
				modal={this.props.modal}
				smallButton={this.props.smallButton}
				withoutContainer={this.props.withoutContainer}
				withoutButton={this.props.withoutButton}
				datatest={this.props.datatest}
				datatestButton={this.props.datatestButton}
				currentAddress={currentAddress}
				currentStreet={currentStreet}
				withBorder={this.props.withBorder}
				buttonName={this.props.buttonName}
				shortButtonName={this.props.shortButtonName}
				withoutShadow={this.props.withoutShadow}
				withoutSwitcher={this.props.withoutSwitcher}
				layoutB={this.props.layoutB}
				onDropdownOpenCallback={() => this.onDropdownOpenCallback()}
				onDropdownCloseCallback={() => this.onDropdownCloseCallback()}
				direction={this.props.direction}
				onEnter={() => this.onEnter()}
				withoutBorder={this.props.withoutBorder}
				whiteTheme={this.props.whiteTheme}
				isFixedList={this.props.isFixedList}
				loading={searcheModel.loading}
				listContainerFunc={this.props.listContainerFunc}
				windowSizes={windowSizes}
				dropdownSelectorVariants={this.dropdownSelectorVariants}
				setRef={(input) => this.setRefHouseDropdown(input)}
				changeSelectRoute={(item) => this.changeSelectRoute(item)}
				focusOnDropdownHouse={() => this.focusOnDropdownHouse()}
				notJustifyCenter={this.props.notJustifyCenter}
				defaultVariantDropdown={
					!!this.props.defaultVariantDropdown ? this.props.defaultVariantDropdown : 0
				}
				onMountSelFil={this.onMountSelFil}
				providerName={providerName}
			/>
		);
	}
}
